<template>
    <div class="notice__item-actions">

        <a href="#" class="notice__item-actions-btn notice__item-actions-btn--primary" @click.prevent="showForm = !showForm" >
            {{$store.getters.t('notice_comment_reply')}}
        </a>

        <transition name="slide">
            <form class="notice__form" action="#" v-show="showForm">
                <fieldset class="notice__form-fieldset">
                    <div class="notice__form-item notice__form-item--full">
                        <textarea rows="4" name="comment" v-model="$v.requestForm.text.$model" :placeholder="$store.getters.t('notice_comment_leave_comment')"></textarea>
                        <div class="field-error-text" v-if="$v.requestForm.text.$error">{{$store.getters.t('notice_comment_length_error')}}</div>
                        <div class="field-error-text"
                             v-if="$v.requestForm.commentable_id.$error || $v.requestForm.commentable_type.$error || $v.requestForm.reply_comment_id.$error">
                            {{$store.getters.t('common_error_retry')}}
                        </div>
                    </div>
                </fieldset>
                <fieldset class="notice__form-fieldset">
                    <div class="notice__form-item notice__form-item--full">
                        <button class="notice__item-actions-btn notice__item-actions-btn--primary" :disabled="$v.requestForm.$invalid"
                                @click.prevent="replyComment">{{$store.getters.t('common_send')}}</button>
                        <button v-if="details && details.comment_id && details.can_delete" class="notice__item-actions-btn btn-danger" @click.prevent="removeComment(details.comment_id)">{{$store.getters.t('common_delete')}}</button>
                    </div>
                </fieldset>
            </form>
        </transition>

    </div>
</template>

<script>

import { required, minLength } from 'vuelidate/lib/validators';

export default {
    name: "NoticeModerationComment",
    props: ['details'],
    data(){
        return{
            showForm: false,
            requestForm: {
                commentable_type: this.details.object_type.indexOf("Pet") >= 0 ? 'pet' : 'project',
                commentable_id: this.details.object_id,
                reply_comment_id: this.details.comment_id,
                text: null,
            }
        }
    },

    mounted(){},

    methods:{

        async removeComment( _idx ){

            try {

                const {
                    data: {
                        data = {},
                        success = false,
                        ...rest
                    }
                } = await axios.delete( `/api/comments/${_idx}` );

                if( success ) {
                    this.$emit('refreshTab');
                }


            } catch ( _e ) {

                console.log( _e );

            }

        },

        async replyComment(){

            this.$v.requestForm.$touch();
            if (this.$v.requestForm.$invalid) {
                return false;
            }

            let params = {
                commentable_type: this.requestForm.commentable_type,
                commentable_id: this.requestForm.commentable_id,
                reply_comment_id: this.requestForm.reply_comment_id,
                text: this.requestForm.text,
            };

            try{

                const { data: { success } = { success: false } /*default data*/ } = await axios.post( '/api/comments', params );

                if( success ) {

                    this.requestForm = Object.assign( {}, this.requestForm, { text: null } );

                    this.$v.requestForm.$reset();

                }


            } catch ( _e ){

                console.log( _e );

            }


        }

    },

    validations:{

        requestForm: {

            commentable_type:{
                required,
                type(val){
                    return val === 'pet' || val === 'project'
                }
            },

            commentable_id:{
                required
            },

            reply_comment_id: {
                required,
            },

            text: {
                required,
            }


        }

    }


}
</script>

<style scoped>

</style>
